import { retrieve } from '@exonet/jsonapi-fetcher/lib/resources';
import { getLocalSettings } from 'app/client/modules/Core/contracts';

export const fetchData = (store) => retrieve(getLocalSettings(), store, false).get();

export default {
  // The boot screen belongs to the first load; over a running app it is a flash.
  renderUpdateLoader: false,

  /**
   * Only mount (fetch) the data if the user is authenticated and the app is unlocked.
   *
   * @param {Object} state The current state.
   * @param {boolean} authenticated If true then the user is authenticated at the API.
   *
   * @returns {boolean} True if the component should mount, false otherwise.
   */
  shouldMount: (state, { authorized }) => authorized,

  /**
   * @type {Function} Fetch data on mount.
   */
  onMount: fetchData,

  /**
   * Only update (fetch) the data if the user is authenticated and the app is unlocked.
   *
   * @param {Object} state The current state.
   * @param {Object} prevProps The previous properties.
   * @param {boolean} authenticated If true then the user is authenticated at the API.
   *
   * @returns {boolean} True if the component should mount, false otherwise.
   */
  shouldUpdate: (state, prevProps, { authorized }) =>
    // If the app is unlocked.
    authorized &&
    // And previously it was not yet unlocked.
    !prevProps.authorized,

  /**
   * @type {Function} Fetch data on update.
   */
  onUpdate: fetchData,
};
